import { IonContent, IonItem, IonPopover } from '@ionic/react';
import useRoutes from '../../../../../hooks/useRoutes';
import { useDatasetContext } from '../../../../../hooks/context/useDatasetContext';

interface PeersetPopoverProps {
  peerset: any;
  triggerId: string;
}

const PeersetPopover = ({ peerset, triggerId }: PeersetPopoverProps) => {
  const { datasetId } = useDatasetContext();
  const routes = useRoutes();

  if (!peerset.peersets) return null;

  return (
    <IonPopover
      trigger={triggerId}
      alignment="start"
      dismissOnSelect={true}
      showBackdrop={false}
    >
      <IonContent className="peersets-popover-content">
        {peerset.peersets.map((item, index) => {
          const isActiveItem = item.datasetId === datasetId;
          const isLastItem = index === peerset.peersets.length - 1;
          return (
            <IonItem
              button={true}
              routerLink={routes.datasetList(item.datasetId)}
              key={item.datasetId}
              color={isActiveItem ? 'primary' : undefined}
              lines={isLastItem || isActiveItem ? 'none' : 'full'}
            >
              {item.label}
            </IonItem>
          );
        })}
      </IonContent>
    </IonPopover>
  );
};

export default PeersetPopover;
